export const categories = [
	'admin',
	'my-performance',
	'transaction-measurement',
	'job-measurement',
	'team-performance',
] as const;

export const ids = [...categories] as const;
